import { getSessionIdentity, bearerHeaders } from '../auth/descope';

export default (id, value) => (dispatch) => {
  const auth = getSessionIdentity();
  if (!auth.email) {
    return;
  }

  dispatch({ type: 'FAVORITE_PORTFOLIO', id, pending: true });

  const body = {
    sedol: null,
    isin: null,
    cusip: null,
    clientEmail: auth.email,
    favorite: value,
  };

  fetch(`${process.env.REACT_APP_DPD_URL}/portfolio/${id}/`, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      ...bearerHeaders(auth),
    },
  })
    .then(d => d.json())
    .then(data => {
      dispatch({ type: 'FAVORITE_PORTFOLIO', id, value });
    })
    .catch(error => {
      console.error(error);
      dispatch({ type: 'FAVORITE_PORTFOLIO', id, pending: false });
    });
};
